import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";
import { swaDate } from "@swa-ui/date";

import { ROUTES } from "./defines/routes";

export function usePassengersPageAnalytics(reservations) {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);

  useEffect(() => {
    if (pathname === ROUTES.passengers) {
      const { itinerary: { bounds = [] } = {}, record_locator } = reservations ?? {};
      const { destinationAirportCode, originationAirportCode, timeToDeparture } =
        getUpcomingTripDetails(bounds);

      setMktgPageData(
        {
          air_confirmationnumber: record_locator ?? "",
          airport_codes:
            destinationAirportCode && originationAirportCode
              ? `${originationAirportCode}:${destinationAirportCode}`
              : "",
          timetodeparture: timeToDeparture?.toString() ?? "",
        },
        "passengersPage"
      );
    }
  }, [pathname, reservations]);

  function getUpcomingTripDetails(bounds) {
    const currentDate = swaDate();
    const upcomingSegmentsList = bounds?.filter(({ segments }) =>
      segments?.some((segment) => {
        const departureTime = swaDate(segment?.departure.scheduled_at);

        return departureTime > currentDate;
      })
    );
    let upcomingSegments = {};

    if (upcomingSegmentsList.length > 0) {
      const { segments } = upcomingSegmentsList[0];

      upcomingSegments = {
        destinationAirportCode: segments.at(-1)?.arrival?.airport,
        originationAirportCode: segments[0]?.departure?.airport,
        timeToDeparture: swaDate(segments[0]?.departure?.scheduled_at).diff(swaDate(), "minutes"),
      };
    }

    return upcomingSegments;
  }
}
